module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_qa-144d1f936d979ff6951b3f17512e6484.svg";